import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Form, FloatingLabel, Button } from 'react-bootstrap'
import DeleteBankDetails from './Modal/DeleteBankDetails'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { IconEdit, IconTrash } from '@tabler/icons-react'
import Markdown from 'react-markdown';
import RemarkGfm from "remark-gfm"
import { toast } from 'react-toastify'
import Loader from '../../Loader'

const Bankdetails = () => {
  const { settingId, currency } = useParams();
  const [loader, setLoader] = useState(false);
  const [DeleteBankDetailsShow, setDeleteBankDetailsShow] = useState(false);
  const token = useSelector((state) => state.token);
  const [isUpdate, setIsUpdate] = useState({ update:false, index:-1 });
  const [setting, setSetting] = useState({});
  const [newBankDetail, setNewBankDetail] = useState("");
  const [bankDetail, setBankDetail] = useState({
    settingId:null,
    bankDetails:[]
  });

  const getBankDetails = () => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/setting/${settingId}`,
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }).then(res => {
      setSetting(res.data.setting);
      setLoader(false);
    }).catch(err => {
      setLoader(false);
    });
  }

  const addBankDetails = (bankDetail) => {
    setLoader(true);
    axios({
      method:"POST",
      url:`${process.env.REACT_APP_BASE_URL}/setting/bank/${settingId}`,
      headers: {
        "Content-Type":"application/json",
        "Authorization":`Bearer ${token}`
      },
      data: JSON.stringify({
        currencyName:currency,
        bankDetail:bankDetail
      })
    }).then(res => {
      setNewBankDetail("");
      setLoader(false);
      setSetting((prevState) => ({
        ...prevState,
        [currency]:{
          ...prevState?.[currency],
          bankDetails: bankDetail
        }
      }));
      toast(res.data.message, {
        type:"success",
        theme:"light",
        position:"top-right"
      })
    }).catch(err => {
      setLoader(false);
      if(err?.response?.data?.errors) {
        toast(err.response.data.errors?.[0].msg, {
          type:"error",
          theme:"light",
          position:"top-right"
        });
      } else {
        toast(err?.response?.data?.message || err.message || "Failed to add bank details", {
          type:"error",
          theme:"light",
          position:"top-right"
        });
      }
    });
  }

  const updateBankDetails = () => {
    setLoader(true);
    axios({
      method:"POST",
      url: `${process.env.REACT_APP_BASE_URL}/setting/bank/${settingId}`,
      headers: {
        "Content-Type":"application/json",
        "Authorization":`Bearer ${token}`
      },
      data: JSON.stringify({
        currencyName:currency,
        bankDetail:setting?.[currency]?.bankDetails
      })
    }).then(res => {
      setLoader(false);
      setNewBankDetail("");
      setIsUpdate((prevState) => ({
        ...prevState,
        index:-1,
        update:false
      }));
      toast("Bank detail update successfully", {
        type:"success",
        theme:"light",
        position:"top-right"
      });
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors?.[0]?.msg, {
          type:"error",
          position:"top-right",
          theme:"light"
        });
      } else {
        toast(err?.response?.data?.message || err?.message || "Failed to update bank detail", {
          type:"error",
          position:"top-right",
          theme: "light"
        })
      }
    });
  }

  useEffect(() => {
    getBankDetails();
  }, []);

  return (
    <>
      <section className='admin_main full'>
        <Container>
          <Row>
            <Col md={12}>
              <Card>
                <Card.Header as="h5">
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="head_title">
                      <h3 className="mb-0">{setting?.[currency] ? `Manage Bank Details for ${currency?.toUpperCase()}` : "Currency not found"}</h3>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    {setting?.[currency]?.bankDetails?.length > 0 ?
                      setting?.[currency].bankDetails.map((p, index) => {
                        return (
                          <Col md={6} className='mb-4'>
                            <Card className="bankinfobox flex-fill">
                              <Card.Body>
                                <Card.Text className='bank-details'>
                                  <div className="btn-wrap">
                                    <Button
                                      onClick={() => {
                                        setNewBankDetail(p);
                                        setIsUpdate((prevState) => ({
                                          ...prevState,
                                          index:index,
                                          update:true
                                        }));
                                      }}
                                      className="button blue p-1 rounded-pill">
                                        <IconEdit size={24} stroke={2} />
                                    </Button>
                                    <Button className="button red p-1 rounded-pill" onClick={() =>{
                                      setBankDetail((prevState) => ({
                                        ...prevState,
                                        bankDetails:setting?.[currency]?.bankDetails.filter((f, i) => i != index),
                                        settingId:settingId
                                      }));
                                      return setDeleteBankDetailsShow(true);
                                    }}>
                                      <IconTrash size={24} stroke={2} />
                                    </Button>
                                  </div>
                                  <p style={{whiteSpace:"pre-line"}}><Markdown remarkPlugins={[RemarkGfm]}>{p}</Markdown></p>
                                </Card.Text>
                              </Card.Body>
                            </Card>
                          </Col>
                        );
                      })
                      : <p>Bank details is not found</p>}
                  </Row>
                  <Row>
                    <Col md={12}>
                      <FloatingLabel controlId="floatingTextarea2" label="Bank details here">
                        <Form.Control
                          as="textarea"
                          placeholder="Leave a comment here"
                          style={{ height: "250px" }}
                          minLength={100}
                          value={newBankDetail}
                          onChange={(t) => {
                            if (isUpdate.update) {
                              const updatedBankDetail = setting?.[currency]?.bankDetails?.map((p, index) => index === isUpdate.index ? t.target.value : p);
                              setSetting((prevState) => ({
                                ...prevState,
                                [currency]:{
                                  ...prevState?.[currency],
                                  bankDetails: updatedBankDetail
                                }
                              }));
                            }
                            setNewBankDetail(t.target.value)
                          }}
                        />
                      </FloatingLabel>
                      <div className="d-flex justify-content-end gap-3 mt-3">
                        { isUpdate.update ?
                          <>
                            <Button onClick={() => {
                              setNewBankDetail("");
                              setIsUpdate((prevState) => ({
                                ...prevState,
                                index:-1,
                                update:false
                              }));
                            }} className='button blue'>Cancel</Button>
                            <Button onClick={() => updateBankDetails()} className='button yellow'>Save</Button>
                          </>
                        :
                        <Button
                          className='button blue'
                          onClick={() =>{
                            const bankDetail = setting?.[currency]?.bankDetails || [];
                            bankDetail.push(newBankDetail);
                            addBankDetails(bankDetail)
                          }}>Add bank details</Button>
                        }
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader}/>
      <DeleteBankDetails
        show={DeleteBankDetailsShow}
        setSetting={setSetting}
        data={bankDetail}
        currencyName={currency}
        onHide={() => setDeleteBankDetailsShow(false)}
      />
    </>
  )
}

export default Bankdetails